const table = [
    {
        prop: 'Cedula',
        label: 'Cédula',
        minWidth: 130
    },
    {
        prop: 'RealizaEncuesta',
        label: 'Realiza Encuesta',
        minWidth: 150
    },
    {
        prop: 'nombres',
        label: 'Nombres',
        minWidth: 200
    },
    {
        prop: 'proyecto',
        label: 'Proyecto',
        minWidth: 180
    },
    {
        prop: 'medio',
        label: 'Medio',
        minWidth: 150
    },
    {
        prop: 'fecha',
        label: 'Fecha',
        minWidth: 130
    },
    {
        prop: 'NivelSatisfaccion',
        label: 'Nivel Satisfaccion',
        minWidth: 150
    },
    {
        prop: 'usuario',
        label: 'Usuario',
        minWidth: 120
    },
    {
        prop: 'ciudad',
        label: 'Ciudad',
        minWidth: 200
    },
]

export default table
